import { mctRequest } from '@/api/axios'
import { downLoadXML, formatXml } from '@/utils/util'

export const getClusterListApi = <T = any>(): Promise<T> => {
  const config = {
    url: '/clusterlist',
    noLoading: true
  }
  return mctRequest.request<T>(config)
}

export const exportClusterApi = async (clusterName: string) => {
  const config = {
    url: `/infrastructure/cluster/${clusterName}`,
    withOutErrorCode: true,
    headers: {
      Accept: 'application/xml'
    }
  }
  const clusterResult = mctRequest.request<any>(config)
  downLoadXML(formatXml(await clusterResult), `Cluster_${clusterName}`)
}

export const importClusterApi = (infrastructure: string, username: string) => {
  const config = {
    url: `/infrastructure?user=${username}`,
    method: 'post',
    data: infrastructure,
    headers: {
      'content-type': 'application/xml'
    }
  }
  return mctRequest.request<any>(config)
}
